// Free gift with purchase (snippets/pdp-free-gift.liquid).
// Add to Cart asks every [data-atc-contributor] element for extra cart lines via getCartItems().
// This element contributes the selected gift, one per main product, tagged _free_gift so gift
// lines can be told apart from paid lines in orders.
if (!customElements.get('pdp-free-gift')) {
  customElements.define(
    'pdp-free-gift',
    class PdpFreeGift extends HTMLElement {
      getSelectedVariantId() {
        return this.querySelector('.pdp-free-gift__input:checked, .pdp-free-gift__input[data-selected]')?.value || null;
      }

      getCartItems(mainQuantity) {
        const id = this.getSelectedVariantId();
        if (!id) return [];
        return [{ id, quantity: mainQuantity, properties: { _free_gift: 'true' } }];
      }
    }
  );
}
